module.exports = __webpack_public_path__ + "img/logo_crop.e8d15c2d.png";